import { Component } from '@angular/core';

@Component({
  selector: 'opac-gradient',
  templateUrl: './gradient.component.html',
  styleUrls: ['./gradient.component.scss'],
})
export class GradientComponent {}
